import { render, staticRenderFns } from "./registeredIncident.vue?vue&type=template&id=de858ce2"
import script from "./registeredIncident.vue?vue&type=script&lang=js"
export * from "./registeredIncident.vue?vue&type=script&lang=js"
import style0 from "./registeredIncident.vue?vue&type=style&index=0&id=de858ce2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports